import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmulshipune() {



  const cardData =
  {
    keyword: 'Cab Service in Mulshi Pune',
    heading: 'Sanavi Travels: Cab Service in Mulshi Pune',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Mulshi Pune, providing safe, comfortable, and convenient transportation for local travel, sightseeing trips, outstation journeys, and corporate visits in the scenic Mulshi region. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free travel experience. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide doorstep pickup and drop services across Mulshi, Pune, and nearby areas, making it ideal for tourist travel, family outings, business trips, and religious visits. Choose Sanavi Travels for trusted cab services in Mulshi Pune, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 by the Peshwas of the Maratha Empire. Known for its massive stone walls, grand gateways, and rich legacy, the fort once served as the seat of Maratha power. The evening light-and-sound show brings Pune’s glorious history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a monument of national importance linked to India’s freedom struggle. Mahatma Gandhi and Kasturba Gandhi were imprisoned here during the Quit India Movement. Today, it houses a museum and memorial surrounded by serene gardens."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is the most revered temple in Pune. The richly adorned idol of Lord Ganesha attracts thousands of devotees daily and becomes the center of grand celebrations during Ganesh Chaturthi."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is famous for the legendary sacrifice of Tanaji Malusare for Chhatrapati Shivaji Maharaj. Located atop a hill, it offers breathtaking views of the Sahyadri ranges and is a popular destination for trekkers and history enthusiasts."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient 8th-century rock-cut shrine dedicated to Lord Shiva. Despite being in the heart of the city, it provides a peaceful spiritual retreat and showcases exceptional early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses an extraordinary collection of over 20,000 artifacts reflecting India’s cultural heritage. Traditional musical instruments, sculptures, and household items make it a must-visit for art and history lovers."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after a short climb. The hilltop temple complex dates back to the Peshwa era and is especially popular during sunrise and sunset."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from around the world. Known for meditation programs and wellness therapies, it is a global center for mindfulness and inner peace."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Inspired by Japan’s Korakuen Garden, Pu La Deshpande Garden is Pune’s largest landscaped park. With bridges, water streams, and lush greenery, it offers a calm escape for families and nature lovers."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a popular leisure spot on the outskirts of Pune. Especially scenic during the monsoon, it offers beautiful sunset views and serves as the gateway to Sinhagad Fort."
  }
]
,



"services": [
{
"name": "Cab Service in Mulshi Pune",
"description": "Cab Service in Mulshi Pune provides reliable and comfortable taxi solutions for local travel, sightseeing, and long-distance journeys. With well-maintained vehicles, experienced drivers, and timely service, it ensures safe and stress-free transportation for residents, tourists, families, and corporate travelers visiting Mulshi."
},
{
"name": "Taxi Service Mulshi",
"description": "Taxi Service Mulshi offers convenient and professional cab services for daily commuting and planned travel. Easy availability, transparent pricing, and courteous drivers make it an ideal choice for local rides, short trips, and nearby travel around Mulshi."
},
{
"name": "AC Cab Mulshi",
"description": "AC Cab Mulshi ensures a cool, comfortable, and relaxed travel experience with fully air-conditioned vehicles. Suitable for long journeys, weekend trips, and family travel, these cabs provide smooth rides and pleasant interiors for all passengers."
},
{
"name": "Local Cab Mulshi",
"description": "Local Cab Mulshi provides quick and hassle-free taxi services for short-distance travel, village transfers, shopping trips, and local sightseeing. Prompt service and knowledgeable drivers make local travel simple and convenient."
},
{
"name": "Outstation Cab Mulshi",
"description": "Outstation Cab Mulshi offers dependable long-distance taxi services to nearby cities, hill stations, and tourist destinations. Comfortable vehicles, skilled drivers, and flexible itineraries ensure a smooth and enjoyable outstation travel experience."
},
{
"name": "Affordable Cab Mulshi",
"description": "Affordable Cab Mulshi delivers budget-friendly taxi services without compromising on safety or comfort. Ideal for families, solo travelers, and groups, it combines economical pricing with reliable and professional service."
},
{
"name": "Chauffeur Driven Cab Mulshi",
"description": "Chauffeur Driven Cab Mulshi provides trained and professional drivers who manage routes, traffic, and schedules efficiently. This service ensures a relaxed and stress-free journey for business travel, leisure trips, and family outings."
},
{
"name": "Best Cab Service Mulshi",
"description": "Best Cab Service Mulshi is known for punctual service, clean vehicles, and a customer-focused approach. Whether for local travel, sightseeing, or outstation trips, it guarantees dependable and comfortable transportation."
},
{
"name": "Tourist Cab Mulshi",
"description": "Tourist Cab Mulshi caters to travelers exploring Mulshi, its scenic surroundings, and nearby attractions. Flexible travel plans, knowledgeable drivers, and comfortable cabs ensure a memorable and enjoyable sightseeing experience."
},
{
"name": "Picnic Cab Mulshi",
"description": "Picnic Cab Mulshi is ideal for family outings, group picnics, and leisure trips to scenic locations around Mulshi. Spacious vehicles and reliable drivers ensure a fun, safe, and relaxed picnic travel experience."
},
{
"name": "Weekend Trip Cab Mulshi",
"description": "Weekend Trip Cab Mulshi offers convenient cab services for short getaways and weekend tours from Mulshi. Perfect for friends, families, and couples seeking a comfortable and well-planned weekend travel experience."
},
{
"name": "Online Cab Booking Mulshi",
"description": "Online Cab Booking Mulshi allows quick and easy cab reservations with instant confirmation. Multiple vehicle options, flexible scheduling, and a simple booking process help travelers plan their journeys efficiently and without hassle."
},
{
"name": "Family Cab Mulshi",
"description": "Family Cab Mulshi provides spacious, safe, and comfortable cabs suitable for family travel. Designed to accommodate all age groups, it ensures a smooth and enjoyable journey for family outings and vacations."
},
{
"name": "Corporate Cab Mulshi",
"description": "Corporate Cab Mulshi offers professional taxi services for executives, meetings, corporate events, and office travel. Punctual pickups, trained drivers, and comfortable vehicles support smooth and efficient business travel."
},
{
"name": "Mulshi Travel Taxi",
"description": "Mulshi Travel Taxi provides complete taxi solutions for local, tourist, and outstation journeys. Combining comfort, safety, affordability, and professional service, it caters to residents, tourists, and corporate clients alike."
}
],
"tableData": [
["Cab Service in Mulshi Pune", "Taxi Service Mulshi"],
["AC Cab Mulshi", "Local Cab Mulshi"],
["Outstation Cab Mulshi", "Affordable Cab Mulshi"],
["Chauffeur Driven Cab Mulshi", "Best Cab Service Mulshi"],
["Tourist Cab Mulshi", "Picnic Cab Mulshi"],
["Weekend Trip Cab Mulshi", "Online Cab Booking Mulshi"],
["Family Cab Mulshi", "Corporate Cab Mulshi"],
["Mulshi Travel Taxi", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Mulshi Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Mulshi Pune for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air-conditioned, and kept clean to ensure a smooth and enjoyable ride around Mulshi Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Mulshi Pune routes, ensuring safe, timely, and pleasant travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear pricing for all cab services in Mulshi Pune, including fuel and tolls, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to help with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local hires, hourly packages, airport transfers, and outstation cab rides based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Mulshi Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Mulshi Pune?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Mulshi Pune for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Mulshi Pune?',
    answer: 'You can book a cab easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab rides are available in Mulshi Pune?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Mulshi Pune.'
  },
  {
    question: 'Are the drivers experienced with routes in Mulshi Pune?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mulshi Pune area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Mulshi Pune.'
  },
  {
    question: 'Is the cab service in Mulshi Pune available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services in Mulshi Pune to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your cab ride in Mulshi Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Patil',
    feedback: 'Booked a cab in Mulshi Pune with Sanavi Travels—excellent service, comfortable ride, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    feedback: 'Great cab service in Mulshi Pune with on-time pickup and clean vehicle. Highly recommended!',
    rating: 5
  }
];











































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Service in Mulshi Pune - Sanavi Travels",
  "description": "Sanavi Travels provides AC, local, outstation, and affordable cabs in Mulshi Pune. Chauffeur-driven taxi service for family trips, corporate travel, picnic, weekend trips, and tourist rides with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "42"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Cab Service in Mulshi Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC, local, outstation, and affordable cabs in Mulshi Pune. Chauffeur-driven taxi service for family trips, corporate travel, picnic, weekend trips, and tourist rides with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/129.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmulshipune;